import { Button } from '@cargomart/ui'
import { useNavigate } from '@tanstack/react-router'
import { Seo } from 'components'
import { useRootLink } from 'hooks/useRootLink'

import { route500 } from '../routes'
import { TechPageTemplate } from '../template'

export const ServerErrorPage = () => {
  const navigate = useNavigate()
  const searchParams = route500.useSearch()
  const from = searchParams.redirectTo
  const rootLink = useRootLink()

  const handleRefreshClick = () => {
    if (!from) {
      return
    }
    navigate({ to: from, replace: true })
  }
  const handleMainPageClick = () => {
    if (!rootLink) {
      return
    }
    navigate({ ...rootLink, replace: true })
  }

  return (
    <>
      <Seo
        description="Сервис грузоперевозок QP5 Express временно недоступен. Мы работаем над устранением проблемы и в ближайшее время вернемся к вам."
        title="Сервис временно недоступен"
      />
      <TechPageTemplate
        text="Мы уже устраняем неисправность, попробуйте обновить страницу через некоторое время. Приносим извинения за временные неудобства."
        title="Ошибка обращения к сервису"
        actions={
          <div className="flex gap-4">
            {from && (
              <Button onClick={handleRefreshClick} size="lg" variant="outline">
                Обновить страницу
              </Button>
            )}
            <Button disabled={!rootLink} onClick={handleMainPageClick} size="lg" variant="outline">
              Перейти на главную
            </Button>
          </div>
        }
        icon={
          <div
            className="mb-5 flex h-[116px] w-[116px] items-center justify-center rounded-full bg-brand text-[48px] text-on-primary md:mb-10"
            data-test-id="server--error--page"
          >
            500
          </div>
        }
      />
    </>
  )
}
